<ng-container *ngIf="vo$ | async; let vo">
	<dx-data-grid
		keyExpr="id"
		[elementAttr]="{
			id: 'subscription-column-config',
			class: 'app-subscription-column-config'
		}"
		[repaintChangesOnly]="true"
		[dataSource]="vo.columnList.elements | toArray"
		[hoverStateEnabled]="true"
		[showColumnHeaders]="true"
		[allowColumnResizing]="true"
		[columnAutoWidth]="false"
		[showRowLines]="false"
		[showColumnLines]="false"
		[rowAlternationEnabled]="false"
		[showBorders]="false"
		[width]="'100%'">

		<dxo-scrolling mode="standard"></dxo-scrolling>
		<!-- Fixable in position columns	-->
		<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

		<dxo-load-panel
			shadingColor="rgba(0,0,0,0)"
			[indicatorSrc]="DcLoaders.LoaderInfinite"
			[height]="100"
			[width]="100"
			[enabled]="true"
			[showIndicator]="true"
			[showPane]="true"
			[shading]="true"></dxo-load-panel>

		<ng-container
			*ngFor="let col of vo.columnList.availableColumns | toArray">
			<dxi-column
				*ngIf="col.field === 'label'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[visible]="!vo.isInModelConfigMode"
				[width]="vo.columnsConfigMode === 'SELECTION'? '30%' : '20%'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'columnType'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[width]="60"
				cellTemplate="columnTypeTemplate"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'alias'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[visible]="vo.columnsConfigMode === 'PARAMETER'"
				[cellTemplate]="
					vo.isInViewMode || vo.isInModelConfigMode ? '' :'aliasTemplate'"
				[width]="'20%'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'description'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[visible]="vo.columnsConfigMode === 'PARAMETER'"
				[width]="vo.isInModelConfigMode? '40%' : '30%'"
				[cellTemplate]="
					vo.isInViewMode || vo.isInModelConfigMode? '' :  'descriptionTemplate'"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'isSelectedInSource'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[visible]="!vo.isInViewMode && !vo.isInModelConfigMode && vo.columnsConfigMode === 'SELECTION'"
				[minWidth]="50"
				[headerCellTemplate]="
					vo.isInViewMode || vo.isInModelConfigMode? '' : 'selectedInSourceHeaderTemplate'"
				cellTemplate="selectedInSourceTemplate"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'isActive'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[visible]="vo.isInModelConfigMode"
				[minWidth]="50"
				[headerCellTemplate]="vo.isInViewMode? '' : 'activeHeaderTemplate'"
				cellTemplate="activeTemplate"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'isDeleted'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[visible]="vo.isInViewMode"
				[minWidth]="70"
				cellTemplate="deletedTemplate"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'referencedBy'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[allowEditing]="false"
				[visible]="vo.isInViewMode ||  vo.columnsConfigMode === 'SELECTION'"
				[minWidth]="70"
				cellTemplate="usagesTemplate"></dxi-column>

			<dxi-column
				*ngIf="col.field === 'isHashed'"
				[dataField]="col.field"
				[caption]="col.alias"
				[groupIndex]="col.groupIdx"
				[visibleIndex]="col.visibleIndex"
				[fixed]="false"
				[allowResizing]="true"
				[allowHiding]="true"
				[allowGrouping]="true"
				[allowSearch]="col.isSearchable"
				[allowFiltering]="col.isFilterable"
				[allowSorting]="true"
				[alignment]="'left'"
				[visible]="vo.isInModelConfigMode"
				[minWidth]="50"
				headerCellTemplate="hashedHeaderTemplate"
				cellTemplate="hashedTemplate"></dxi-column>
		</ng-container>

		<div *dxTemplate="let cell of 'aliasTemplate'">
				<dx-text-box
					[value]="cell.data['alias']"
					[validationStatus]="
						cell.data['errors'].has(ColumnErrorTypes.EMPTY)
						|| cell.data['errors'].has(ColumnErrorTypes.DUPLICATED)
						|| cell.data['errors'].has(ColumnErrorTypes.NOT_NORMALIZE) ? 'invalid' : 'valid'"
					[validationError]="{ message:
						cell.data['errors'].has(ColumnErrorTypes.EMPTY) ? MapErrors[ColumnErrorTypes.EMPTY]
						 : cell.data['errors'].has(ColumnErrorTypes.DUPLICATED) ? MapErrors[ColumnErrorTypes.DUPLICATED]
 						 : cell.data['errors'].has(ColumnErrorTypes.NOT_NORMALIZE) ? MapErrors[ColumnErrorTypes.NOT_NORMALIZE]
 						 : ''}"
					[disabled]="!cell.data['isSelectedInSource']"
					(onValueChanged)="updateUsedAlias(cell.key, $event)"
					(onKeyDown)="onTextBoxKeyDown($event)"></dx-text-box>
		</div>

		<div *dxTemplate="let cell of 'selectedInSourceTemplate'">
			<mat-slide-toggle
				color="primary"
				[disabled]="cell.data['referencedBy'].total !== 0"
				[checked]="cell.data['isSelectedInSource']"
				(change)="updateIsSelectedInSource(cell.key, $event.checked)"></mat-slide-toggle>
		</div>

		<div
			*dxTemplate="let cell of 'selectedInSourceHeaderTemplate'"
			class="active-header">
			<div [ngClass]="{ 'selected-in-source-template-error' : vo.selectedColumnCount === 0}">
				<span
					i18n="@@subscription.columns.config.list.column.selectedInSource">
					selected-in-source</span>
				({{vo.selectedColumnCount}})
			</div>
			<div (click)="toggleAllTriggered($event)">
				<mat-slide-toggle
					color="primary"
					[disabled]="!vo.enableSelectedInSourceAll"
					[checked]="vo.columnList.isAllSelectedInSource"
					(change)="toggleSelectedInSourceAllRows($event.checked)"></mat-slide-toggle>
			</div>
		</div>

		<div *dxTemplate="let cell of 'activeTemplate'">
				<mat-slide-toggle
					*ngIf="!vo.isInViewMode"
					color="primary"
					[checked]="cell.data['isActive']"
					(change)="updateIsActive(cell.key, $event.checked)"></mat-slide-toggle>
				<!--<mat-icon
					*ngIf="vo.isInViewMode && cell.data['isActive']"
					class="is-active-column"
					[svgIcon]="DcIcons.Check"></mat-icon>
				<mat-icon
					*ngIf="vo.isInViewMode && !cell.data['isActive']"
					class="is-no-active-column"
					[svgIcon]="DcIcons.Check"></mat-icon>-->
		</div>

		<div
			*dxTemplate="let cell of 'activeHeaderTemplate'"
			class="active-header">
			<span
				i18n="@@subscription.columns.config.list.column.active">
				active</span>
			<div (click)="toggleAllTriggered($event)">
				<mat-slide-toggle
					color="primary"
					[checked]="vo.columnList.isAllActive"
					(change)="toggleActiveAllRows($event.checked)"></mat-slide-toggle>
			</div>
		</div>

		<div
			*dxTemplate="let cell of 'deletedTemplate'"
			class="deleted-template">
			<div
				*ngIf="cell.data['isDeleted']"
				class="status-badge warning">
				<mat-icon
					[svgIcon]="DcIcons.Warning"></mat-icon>
				<span
					i18n="@@subscription.column.deleted">
					deleted</span>
			</div>
		</div>

		<div
			*dxTemplate="let cell of 'usagesTemplate'"
			class="usages-template">
			<app-overlay-badge
				*ngIf="cell.data['referencedBy'].profiles.length !== 0"
				[icon]="ComponentIcons.Profile"
				[value]="cell.data['referencedBy'].profiles.length"
				[active]="true"
				[isOpen]="vo.openedOverlay.type === 'profile' && vo.openedOverlay.columnId === cell.data['id']"
				(overlayDismiss)="closeColumnsPopover()"
				(click)="openReferences($event, cell.data, 'profile')">
				<app-popover
					overlayContent
					label="profiles"
					i18n-label="@@subscription.columnModel.list.column.profiles"
					[icon]="{ iconName: ComponentIcons.Profile }"
					[count]="cell.data['referencedBy'].profiles.length"
					(adbPopoverClose)="closeColumnsPopover()">
					<div class="columns-usage-details">
						<ng-container *ngFor="let usage of vo.openedOverlay.usages">
							<span>{{ usage.label }}</span>
						</ng-container>
					</div>
				</app-popover>
			</app-overlay-badge>

			<app-overlay-badge
				*ngIf="cell.data['referencedBy'].columnModels.length !== 0"
				[icon]="ComponentIcons.Column"
				[value]="cell.data['referencedBy'].columnModels.length"
				[active]="true"
				[isOpen]="vo.openedOverlay.type === 'colModel' && vo.openedOverlay.columnId === cell.data['id']"
				(overlayDismiss)="closeColumnsPopover()"
				(click)="openReferences($event, cell.data, 'colModel')">
				<app-popover
					overlayContent
					label="columns"
					i18n-label="@@subscription.columnModel.list.column.columns"
					[icon]="{ iconName: ComponentIcons.Column }"
					[count]="cell.data['referencedBy'].columnModels.length"
					(adbPopoverClose)="closeColumnsPopover()">
					<div class="columns-usage-details">
						<ng-container *ngFor="let usage of vo.openedOverlay.usages">
							<span>{{ usage.label }}</span>
						</ng-container>
					</div>
				</app-popover>
			</app-overlay-badge>

			<app-overlay-badge
				*ngIf="cell.data['referencedBy'].filterModels.length !== 0"
				[icon]="ComponentIcons.Filter"
				[value]="cell.data['referencedBy'].filterModels.length"
				[active]="true"
				[isOpen]="vo.openedOverlay.type === 'filterModel' && vo.openedOverlay.columnId === cell.data['id']"
				(overlayDismiss)="closeColumnsPopover()"
				(click)="openReferences($event, cell.data, 'filterModel')">
				<app-popover
					overlayContent
					label="filtres"
					i18n-label="@@subscription.consumedProject.list.column.filters"
					[icon]="{ iconName: ComponentIcons.Filter }"
					[count]="cell.data['referencedBy'].filterModels.length"
					(adbPopoverClose)="closeColumnsPopover()">
					<div class="columns-usage-details">
						<ng-container *ngFor="let usage of vo.openedOverlay.usages">
							<span>{{ usage.label }}</span>
						</ng-container>
					</div>
				</app-popover>
			</app-overlay-badge>
		</div>

		<div
			*dxTemplate="let cell of 'hashedTemplate'"
			class="hashed-template">
			<mat-slide-toggle
				*ngIf="HASHED_COLUMN_TYPES.includes(cell.data['columnType'])"
				color="primary"
				[disabled]="!cell.data['isActive']"
				[checked]="cell.data['isHashed']"
				(change)="updateIsHashed(cell.key, $event.checked)"></mat-slide-toggle>
		</div>

		<div
			*dxTemplate="let cell of 'hashedHeaderTemplate'"
			class="hashed-header">
			<span
				i18n="@@subscription.columns.config.list.column.hashable">
				hashable</span>
			<div (click)="toggleAllTriggered($event)">
				<mat-slide-toggle
					color="primary"
					[disabled]="!vo.enableHashedAll"
					[checked]="vo.columnList.isAllHashed"
					(change)="toggleHashableAllRows($event.checked)"></mat-slide-toggle>
			</div>
		</div>

		<div
			*dxTemplate="let cell of 'columnTypeTemplate'"
			class="column-type-template">
			<app-column-type
				[type]="cell.data['columnType']"
				[isList]="cell.data['isList']"></app-column-type>
		</div>

		<div *dxTemplate="let cell of 'descriptionTemplate'">
			<dx-text-box
				[value]="cell.data['description']"
				[validationStatus]="
						cell.data['errors'].has(ColumnErrorTypes.MAX_LENGTH_DESC)? 'invalid' : 'valid'"
				[validationError]="{ message:
						cell.data['errors'].has(ColumnErrorTypes.MAX_LENGTH_DESC) ?
						MapErrors[ColumnErrorTypes.MAX_LENGTH_DESC]
						: ''}"
				[disabled]="!cell.data['isSelectedInSource']"
				(onKeyDown)="onTextBoxKeyDown($event)">
				<dx-validator (onValidated)="updateDescription(cell.key, $event)">
					<dxi-validation-rule
						[max]="100"
						type="stringLength"
						message="max: 2500!"
						i18n-message="
							@@general.form.errors.maxlength"></dxi-validation-rule>
				</dx-validator>
			</dx-text-box>
		</div>


		<dxo-group-panel [visible]="false"></dxo-group-panel>

		<!-- Search input -->
		<dxo-search-panel [visible]="false"></dxo-search-panel>

		<!-- Sorting	-->
		<dxo-sorting mode="multiple"></dxo-sorting>

		<!-- Pagination -->
		<dxo-paging [pageSize]="1000"></dxo-paging>

		<dxo-pager [visible]="false"></dxo-pager>

		<!-- Filterable columns	-->
		<dxo-filter-row [visible]="true"></dxo-filter-row>

		<!-- State persistence	-->
		<dxo-state-storing
			type="localStorage"
			[enabled]="false"
			[storageKey]="dxLocalStorageKey"></dxo-state-storing>
	</dx-data-grid>
</ng-container>
